var collectionFilter = {
  init: function (settings) {
    collectionFilter.config = {
      collectionUrl    : $('.collection-sidebar').data('collection-url'),
      filterItemClass  : '.js-collection-sidebar__filter-item',
      productsContainer: $('.js-collection-grid__products'),
      productCount     : $('.js-product-grid__count'),
      layout           : $('.js-collection-layout'),
      sortInput        : $('.js-collection-sort__input'),
      url              : window.location.origin + window.location.pathname,
    };

    $.extend(collectionFilter.config, settings);

    collectionFilter.loadActiveTags();
    collectionFilter.setTagFilter();
    collectionFilter.setSortBy();
    collectionFilter.paginate();
  },

  loadActiveTags: function () {
    $(collectionFilter.config.filterItemClass).each(function () {
      var tag = $(this).data('tag');

      if (collectionFilter.config.url.indexOf(tag) > -1) {
        $(this).addClass('active');
      }
    });
  },

  setTagFilter: function () {
    $(document).on('change', collectionFilter.config.filterItemClass, function () {
      var search = window.location.search;

      if (search.indexOf('page') !== -1) {
        var pageParam = search.split('&')[0];
        search        = search.replace(pageParam, '').replace('&', '?');
      }

      $(this).toggleClass('active');

      var activeItems = $('.collection-sidebar').find(collectionFilter.config.filterItemClass + '.active'),
          activeTags  = [];

      activeItems.each(function (index, el) {
        var tag = $(el).attr('data-tag');

        if (tag) {
          activeTags.push(tag);
        }
      });

      var tagsUrl = activeTags.join('+');

      var newUrl = collectionFilter.config.collectionUrl;

      if (tagsUrl) {
        newUrl += '/' + tagsUrl;
      }

      newUrl += search;

      collectionFilter.config.layout.addClass('ajax-loading');

      $.get({
        url    : newUrl,
        success: function (data) {
          var newProductsWrapper = $(data).find('.js-collection-grid__products'),
              newProductsHtml    = newProductsWrapper.html(),
              newItemCount       = newProductsWrapper.attr('data-products-count');

          collectionFilter.config.productsContainer.html(newProductsHtml);
          collectionFilter.config.productCount.text(newItemCount);

          history.pushState(
            {
              page: newUrl
            },
            null,
            newUrl
          );
          collectionFilter.paginate();
          collectionFilter.config.layout.removeClass('ajax-loading');
        },
        error  : function (request, status, error) {
          console.error(request.status + ': ' + request.responseText);
        }
      });
      collectionFilter.paginate();
    });
  },

  setSortBy: function () {
    $(collectionFilter.config.sortInput).on('change', function () {
      var urlSearchParams = new URLSearchParams(window.location.search);

      urlSearchParams.set(this.name, this.value);

      collectionFilter.config.layout.addClass('ajax-loading');

      $.get({
        url    : `?${urlSearchParams}`,
        success: function (data) {
          var newProductsWrapper = $(data).find('.js-collection-grid__products'),
              newProductsHtml    = newProductsWrapper.html();

          collectionFilter.config.productsContainer.html(newProductsHtml);

          history.pushState(
            {
              page: `?${urlSearchParams}`
            },
            null,
            `?${urlSearchParams}`
          );

          collectionFilter.config.layout.removeClass('ajax-loading');
        },
        error  : function (request, status, error) {
          console.error(request.status + ': ' + request.responseText);
        }
      });
    });
  },

  paginate: function () {
    var itemCount       = collectionFilter.config.productCount.text(),
        itemsPerPage    = collectionFilter.config.productCount.attr('data-items-per-page'),
        paginateWrapper = $('.js-collection-pagination');

    if (parseInt(itemCount) > parseInt(itemsPerPage)) {
      paginateWrapper.show();
    } else {
      paginateWrapper.hide();
    }
  },
};

$(document).ready(
  collectionFilter.init
);

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Ajaxinate != 'undefined' && Ajaxinate != null) {
    var endlessScroll = new Ajaxinate({
      method: 'click',
    });
  }
});

$(document).ready(function () {
  if (window.location.pathname !== '/challenge' && window.location.pathname !== '/account/login') {
    localStorage.setItem('returnToUrl', window.location.pathname + window.location.search);
  } else {
    if ($('.shopify-challenge__container form').length) {
      if (localStorage.getItem('returnToUrl')) {
        var newInput = $(`<input type="hidden" name="return_to" value="${localStorage.getItem('returnToUrl')}" />`);
        newInput.insertBefore($('.shopify-challenge__container input[type="submit"]'));
      }
    }
  }
  $('.js-customer-login').val(localStorage.getItem('returnToUrl'));
});

$(document).ready(function () {
  document.onscroll = function() {
    setStickyNav();
    showScrollButton();
  };

  var announcementBar = $('.js-announcement-bar');
  var header          = $('.js-header');
  var navBar          = $('.js-nav-bar');
  var main            = $('.js-main');

  var headerOffset = header.outerHeight(true) + announcementBar.outerHeight(true);

  function setStickyNav() {
    if (window.pageYOffset > headerOffset && window.innerWidth > 999) {
      navBar.addClass('sticky-nav');
      main.css('padding-top', '65px');
    } else {
      navBar.removeClass('sticky-nav');
      main.css('padding-top', '0px');
    }
  }

  var toTopButton = $('.back-to-top');

  function showScrollButton() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      toTopButton.fadeIn();
    } else {
      toTopButton.fadeOut();
    }
  }

  toTopButton.on('click', function () {
    document.body.scrollTop            = 0;
    document.documentElement.scrollTop = 0;
  });
});
